import React, { useEffect, useState, createElement } from 'react';
import { Routes, Route } from 'react-router-dom';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';
import { ForumPost } from './components/ForumPost';
import { forumPosts, PostData } from './data/forumData';
import { ModalProvider } from './components/BlurredBadge';
import { CookieBanner } from './components/CookieBanner';
import { Impressum } from './pages/Impressum';
import { Datenschutz } from './pages/Datenschutz';
import { Nutzungsbedingungen } from './pages/Nutzungsbedingungen';
import { Kontakt } from './pages/Kontakt';
export function App() {
  const [posts, setPosts] = useState<PostData[]>(forumPosts);
  const [replyText, setReplyText] = useState('');
  useEffect(() => {
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      (window as any).fbq('init', '1501611034718587');
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  const handleSubmit = () => {
    const trimmed = replyText.trim();
    if (!trimmed) return;
    const now = new Date();
    const pad = (n: number) => String(n).padStart(2, '0');
    const dateStr = `${pad(now.getDate())}.${pad(now.getMonth() + 1)}.${now.getFullYear()}, ${pad(now.getHours())}:${pad(now.getMinutes())}`;
    const paragraphs = trimmed.split('\n').filter(line => line.trim() !== '');
    const newPost: PostData = {
      id: posts.length + 1,
      avatar: {
        letter: 'G',
        color: 'gray'
      },
      username: 'Gast',
      role: 'Mitglied',
      stats: {
        joined: `${pad(now.getDate())}.${pad(now.getMonth() + 1)}.${now.getFullYear()}`,
        posts: 1
      },
      datetime: dateStr,
      content: <>
          {paragraphs.map((p, i) => <p key={i} data-id="element-0">{p}</p>)}
        </>
    };
    setPosts(prev => [...prev, newPost]);
    setReplyText('');
  };
  const forumHome = <div className="min-h-screen bg-[#f4f2ee] font-sans text-[#1a1a1a] text-[14px]" data-id="element-1">
      <SiteHeader data-id="element-2" />

      {/* Breadcrumb */}
      <div className="max-w-[900px] mx-auto px-[20px] py-[10px] text-[11px] text-[#888] overflow-hidden text-ellipsis whitespace-nowrap" data-id="element-3">
        ViWe Forum ›{' '}
        <span className="text-[#555]" data-id="element-4">Gesundheit & Wohlbefinden</span> ›{' '}
        <span className="text-[#555]" data-id="element-5">Männergesundheit</span>
      </div>

      {/* Forum Wrap */}
      <div className="max-w-[900px] mx-auto px-[20px] pb-[40px]" data-id="element-6">
        {/* Forum Header */}
        <div className="border-b-[2px] border-[#c8c0b0] pt-[1rem] pb-[0.75rem] mb-[1.25rem]" data-id="element-7">
          <div className="text-[11px] text-[#888] tracking-[0.08em] uppercase mb-[0.4rem]" data-id="element-8">
            Gesundheit & Wohlbefinden › Vitalität & Alltag
          </div>
          <div className="md:text-[19px] font-bold text-[#1a1a1a] text-[40px]" data-id="element-9">
            Männer ab 45: Das nächtliche Aufstehen ist kein Zufall — ignoriert
            das nicht
          </div>
          <div className="flex flex-wrap gap-x-[1.5rem] gap-y-[0.25rem] mt-[0.5rem] text-[12px] text-[#888]" data-id="element-10">
            <span data-id="element-11">{posts.length - 1} Antworten</span>
            <span data-id="element-12">75.213 Aufrufe</span>
            <span data-id="element-13">Erstellt: 26.04.2026</span>
          </div>
        </div>

        {/* Tabs */}
        <div className="flex border-b border-[#ddd] mb-[1.25rem] overflow-x-auto" data-id="element-14">
          <div className="px-[0.75rem] md:px-[1rem] py-[0.5rem] text-[12px] font-medium text-[#1a1a1a] border-b-[2px] border-[#1a2e4a] tracking-[0.04em] uppercase cursor-default whitespace-nowrap" data-id="element-15">
            Beiträge
          </div>
          <div className="px-[0.75rem] md:px-[1rem] py-[0.5rem] text-[12px] font-medium text-[#888] border-b-[2px] border-transparent tracking-[0.04em] uppercase cursor-default whitespace-nowrap" data-id="element-16">
            Letzte Aktivität
          </div>
          <div className="px-[0.75rem] md:px-[1rem] py-[0.5rem] text-[12px] font-medium text-[#888] border-b-[2px] border-transparent tracking-[0.04em] uppercase cursor-default whitespace-nowrap" data-id="element-17">
            Bilder
          </div>
        </div>

        {/* Search Bar */}
        <div className="flex flex-wrap justify-between items-center gap-[8px] mb-[1rem]" data-id="element-18">
          <input className="bg-white border border-[#ddd] rounded-[4px] px-[10px] py-[5px] text-[12px] text-[#555] w-[140px] md:w-[160px] outline-none" type="text" placeholder="Suchen" data-id="element-19" />
          <div className="flex items-center gap-[6px] text-[12px] text-[#888]" data-id="element-20">
            Seite <span className="font-bold text-[#1a1a1a]" data-id="element-21">1</span> von 1
            <div className="bg-white border border-[#ddd] rounded-[3px] px-[7px] py-[2px] text-[11px] text-[#555] cursor-default" data-id="element-22">
              ◀
            </div>
            <div className="bg-white border border-[#ddd] rounded-[3px] px-[7px] py-[2px] text-[11px] text-[#555] cursor-default" data-id="element-23">
              ▶
            </div>
            <div className="bg-transparent border border-[#ddd] rounded-[4px] px-[10px] py-[4px] text-[12px] text-[#555] cursor-default hidden sm:block" data-id="element-24">
              ⊟ Filter
            </div>
          </div>
        </div>

        {/* Posts */}
        <div className="flex flex-col" data-id="element-25">
          {posts.map(post => <ForumPost key={post.id} post={post} data-id="element-26" />)}
        </div>
      </div>

      {/* Thread Footer */}
      <div className="max-w-[900px] mx-auto px-[20px] pb-[40px]" data-id="element-27">
        <div className="flex items-center gap-[12px] my-[24px] mb-[20px]" data-id="element-28">
          <span className="flex-1 h-[1px] bg-[#ddd]" data-id="element-29"></span>
          <span className="text-[11px] text-[#aaa] whitespace-nowrap tracking-[0.05em]" data-id="element-30">
            — Ende des Threads —
          </span>
          <span className="flex-1 h-[1px] bg-[#ddd]" data-id="element-31"></span>
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-[12px] mb-[20px]" data-id="element-32">
          <div className="text-[12px] text-[#888]" data-id="element-33">
            Seite <strong className="text-[#1a1a1a]" data-id="element-34">1</strong> von 1
            &nbsp;|&nbsp;
            <span className="text-[#999]" data-id="element-35">75.213 Aufrufe</span> &nbsp;|&nbsp;
            <span className="text-[#999]" data-id="element-36">{posts.length} Antworten</span>
          </div>
          <div className="flex gap-[8px]" data-id="element-37">
            <button className="bg-transparent text-[#555] border border-[#ddd] rounded-[4px] px-[12px] md:px-[16px] py-[7px] text-[12px] font-medium cursor-pointer" data-id="element-38">
              Thema abonnieren
            </button>
            <button className="bg-[#1a2e4a] text-white border-none rounded-[4px] px-[12px] md:px-[16px] py-[7px] text-[12px] font-semibold cursor-pointer" data-id="element-39">
              Antworten
            </button>
          </div>
        </div>

        <div className="bg-white border border-[#ddd] rounded-[6px] p-[16px]" data-id="element-40">
          <div className="text-[12px] font-semibold text-[#555] mb-[8px] uppercase tracking-[0.04em]" data-id="element-41">
            Deine Antwort
          </div>
          <textarea className="w-full h-[90px] border border-[#e0ddd8] rounded-[4px] p-[10px] text-[13px] font-inherit text-[#1a1a1a] resize-y outline-none bg-[#fafaf8] focus:border-[#1a2e4a]" placeholder="Schreibe hier deine Antwort..." value={replyText} onChange={e => setReplyText(e.target.value)} data-id="element-42"></textarea>
          <div className="flex justify-between items-center mt-[10px]" data-id="element-43">
            <span className="text-[11px] text-[#bbb]" data-id="element-44">
              Bitte bleib respektvoll und sachlich.
            </span>
            <button className="bg-[#1a2e4a] text-white border-none rounded-[4px] px-[16px] py-[7px] text-[12px] font-semibold cursor-pointer disabled:opacity-50 disabled:cursor-default" onClick={handleSubmit} disabled={!replyText.trim()} data-id="element-45">
              Beitrag absenden
            </button>
          </div>
        </div>
      </div>

      {/* Journal & Ratgeber */}
      <div className="max-w-[900px] mx-auto px-[20px] pb-[40px]" data-id="element-46">
        <div className="flex items-center gap-[12px] mt-[32px] mb-[20px]" data-id="element-47">
          <span className="flex-1 h-[1px] bg-[#ddd]" data-id="element-48"></span>
          <span className="text-[11px] text-[#aaa] whitespace-nowrap tracking-[0.05em] uppercase" data-id="element-49">
            Aus dem ViWe Ratgeber
          </span>
          <span className="flex-1 h-[1px] bg-[#ddd]" data-id="element-50"></span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-[16px] mb-[32px]" data-id="element-51">
          <a href="#" className="bg-white border border-[#ddd] rounded-[6px] overflow-hidden group block no-underline" data-id="element-52">
            <div className="bg-[#e8e4dc] h-[110px] flex items-center justify-center" data-id="element-53">
              <span className="text-[28px]" data-id="element-54">🛏️</span>
            </div>
            <div className="p-[14px]" data-id="element-55">
              <div className="text-[10px] text-[#999] uppercase tracking-[0.06em] mb-[4px]" data-id="element-56">
                Naturheilkunde
              </div>
              <div className="text-[14px] font-semibold text-[#1a1a1a] leading-[1.35] group-hover:text-[#1a2e4a]" data-id="element-57">
                Betrachtung ausgewählter Pflanzenstoffe
              </div>
              <p className="text-[12px] text-[#777] mt-[6px] leading-[1.5]" data-id="element-58">
                Eine Zusammenfassung von Merkmalen verschiedener natürlicher
                Extrakte und deren Herkunft.
              </p>
              <div className="text-[11px] text-[#aaa] mt-[8px]" data-id="element-59">
                24. April 2026 · 6 Min. Lesezeit
              </div>
            </div>
          </a>

          <a href="#" className="bg-white border border-[#ddd] rounded-[6px] overflow-hidden group block no-underline" data-id="element-60">
            <div className="bg-[#dce4e0] h-[110px] flex items-center justify-center" data-id="element-61">
              <span className="text-[28px]" data-id="element-62">🌿</span>
            </div>
            <div className="p-[14px]" data-id="element-63">
              <div className="text-[10px] text-[#999] uppercase tracking-[0.06em] mb-[4px]" data-id="element-64">
                Naturheilkunde
              </div>
              <div className="text-[14px] font-semibold text-[#1a1a1a] leading-[1.35] group-hover:text-[#1a2e4a]" data-id="element-65">
                Botanische Klassifizierung einheimischer Nutzpflanzen-Extrakte
              </div>
              <p className="text-[12px] text-[#777] mt-[6px] leading-[1.5]" data-id="element-66">
                Eine Auflistung systematischer Bezeichnungen und deren
                Lagerungsbedingungen in geschlossenen Behältnissen.
              </p>
              <div className="text-[11px] text-[#aaa] mt-[8px]" data-id="element-67">
                21. April 2026 · 8 Min. Lesezeit
              </div>
            </div>
          </a>

          <a href="#" className="bg-white border border-[#ddd] rounded-[6px] overflow-hidden group block no-underline" data-id="element-68">
            <div className="bg-[#e0dce8] h-[110px] flex items-center justify-center" data-id="element-69">
              <span className="text-[28px]" data-id="element-70">🧠</span>
            </div>
            <div className="p-[14px]" data-id="element-71">
              <div className="text-[10px] text-[#999] uppercase tracking-[0.06em] mb-[4px]" data-id="element-72">
                Alltag
              </div>
              <div className="text-[14px] font-semibold text-[#1a1a1a] leading-[1.35] group-hover:text-[#1a2e4a]" data-id="element-73">
                Aspekte der Beschaffung und Vorhaltung von Lebensmitteln
              </div>
              <p className="text-[12px] text-[#777] mt-[6px] leading-[1.5]" data-id="element-74">
                Ein Leitfaden über die logistischen Abläufe beim Einkauf und die
                anschließende Lagerung im Haushalt.
              </p>
              <div className="text-[11px] text-[#aaa] mt-[8px]" data-id="element-75">
                18. April 2026 · 5 Min. Lesezeit
              </div>
            </div>
          </a>

          <a href="#" className="bg-white border border-[#ddd] rounded-[6px] overflow-hidden group block no-underline" data-id="element-76">
            <div className="bg-[#e8dcd4] h-[110px] flex items-center justify-center" data-id="element-77">
              <span className="text-[28px]" data-id="element-78">💬</span>
            </div>
            <div className="p-[14px]" data-id="element-79">
              <div className="text-[10px] text-[#999] uppercase tracking-[0.06em] mb-[4px]" data-id="element-80">
                Partnerschaft
              </div>
              <div className="text-[14px] font-semibold text-[#1a1a1a] leading-[1.35] group-hover:text-[#1a2e4a]" data-id="element-81">
                Kommunikationsmuster im häuslichen Umfeld
              </div>
              <p className="text-[12px] text-[#777] mt-[6px] leading-[1.5]" data-id="element-82">
                Erläuterungen zu zwischenmenschlichen Abläufen bei abweichenden
                Regenerationszeiten.
              </p>
              <div className="text-[11px] text-[#aaa] mt-[8px]" data-id="element-83">
                15. April 2026 · 7 Min. Lesezeit
              </div>
            </div>
          </a>
        </div>

        {/* Beliebte Themen */}
      </div>

      {/* Anzeige Disclaimer */}
      <div className="max-w-[900px] mx-auto px-[20px] pb-[24px]" data-id="element-84">
        <p className="text-[10px] text-[#aaa] leading-[1.6] text-center" data-id="element-85">
          Anzeige — Bezahlter Werbebeitrag. Dieser Erfahrungsbericht dient der
          Information und ersetzt keine ärztliche Diagnose oder Behandlung.
          Ergebnisse sind individuell und nicht garantiert. Die Anwendung
          ersetzt keine gesunde Lebensweise. Konsultieren Sie bei medizinischen
          Fragen stets einen Facharzt.
        </p>
      </div>

      <SiteFooter data-id="element-86" />
    </div>;
  return <ModalProvider data-id="element-87">
      <Routes data-id="element-88">
        <Route path="/" element={forumHome} data-id="element-89" />
        <Route path="/impressum" element={<Impressum data-id="element-91" />} data-id="element-90" />
        <Route path="/datenschutz" element={<Datenschutz data-id="element-93" />} data-id="element-92" />
        <Route path="/nutzungsbedingungen" element={<Nutzungsbedingungen data-id="element-95" />} data-id="element-94" />
        <Route path="/kontakt" element={<Kontakt data-id="element-97" />} data-id="element-96" />
      </Routes>
      <CookieBanner data-id="element-98" />
    </ModalProvider>;
}